// extracted by mini-css-extract-plugin
module.exports = {"root":"Statistics_root__S8cW7"};